'use client';

import { DepopCommunity } from '@depop/web-thrift-ui/Illustrations/DepopCommunity';
import { Caption, Heading } from '@depop/web-thrift-ui/Typography';
import { IconDepopIcon } from '@depop/web-ui-kit/Icons/IconDepopIcon';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { ExtendedLink } from '../ExtendedLink';

import styles from './styles.module.css';

import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  className?: string;
};

export function CombinedFlowHeader({ className }: Props) {
  const t = useTranslations('common');
  const [, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  function handleLogoClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: 'depop_logo_checkout_cta',
    });
  }
  return (
    <header role="banner" className={clsx(styles.header, className)}>
      <ExtendedLink
        href="/"
        onClick={handleLogoClick}
        aria-label="Depop homepage"
      >
        <IconDepopIcon className={styles.depopLogo} title="Depop logo" />
      </ExtendedLink>
      <Heading className={styles.title} variant="md">
        {t('CombinedFlowHeader.Title')}
      </Heading>
      <div className={styles.buyerProtection}>
        <DepopCommunity size="xSmall" />
        <Caption colour="subtle" variant="lg-regular">
          {t('CombinedFlowHeader.BuyerProtectTitle')}
        </Caption>
      </div>
    </header>
  );
}
